import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select/creatable';
import InputMask from 'react-input-mask';
import { Container, Box } from './styles';

const FieldSelect = ({
  options,
  label,
  id,
  callBack,
  error,
  onChange,
  value,
  ...props
}) => {
  const customStyles = {
    control: (base) => ({
      ...base,
      minHeight: '100%',
      border: `1px solid ${error ? '#ed4343' : '#dfe3e8'}`,
      borderRadius: '4px 0px 0px 4px',
      flex: '1',
      transition: 'all ease 0.2s',
      boxShadow: 'none',
      marginLeft: 'none',
      'div + div': {
        marginLeft: 'none',
      },

      '&:hover': {
        borderColor: `1px solid ${error ? '#ed4343' : '#dfe3e8'}`,
      },

      '&::focus': {
        outline: 'none',
        borderColor: `1px solid ${error ? '#ed4343' : '#dfe3e8'}`,
      },
    }),
    container: (base) => ({
      ...base,
      flex: '0 1 28%',
      fontSize: '14px',
      'div + div': {
        marginLeft: 'none',
      },
    }),
  };
  return (
    <Container error={error}>
      <label htmlFor={id}>{label}</label>
      <Box>
        <Select
          id={id}
          defaultValue={options && options[0]}
          styles={customStyles}
          options={options}
          onChange={(event) => {
            callBack(event);
          }}
        />
        <InputMask
          data-testid="input"
          onChange={onChange}
          value={value}
          {...props}
        />
      </Box>
      {error && <span data-testid="validator">{error}</span>}
    </Container>
  );
};

FieldSelect.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ),
  label: PropTypes.string,
  value: PropTypes.string,
  callBack: PropTypes.func,
  onChange: PropTypes.func,
  id: PropTypes.string,
  error: PropTypes.any,
};

FieldSelect.defaultProps = {
  options: null,
  label: null,
  id: null,
  error: null,
  value: '',
  callBack: (event) => {
    return event;
  },
  onChange: (event) => {
    return event;
  },
};

export default FieldSelect;
